// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"profile_dashboardContainer__GmW7Y","MuiGrid-item":"profile_MuiGrid-item__jsgR4","MuiPaper-root":"profile_MuiPaper-root__-lQ0M"};